import { Tabs } from 'antd'

import { AppAdmin } from 'api/app-admin'
import { PtoReferralOverviewCards } from 'modules/pto-referral/overview-cards'

import { PartnerPtosTable } from './partner-ptos-table'
import { PartnerUsersTable } from './partner-users-table'

export const PartnerReferral = () => {
  const tabItems = [
    {
      key: 'ptos',
      label: 'PTOs',
      children: <PartnerPtosTable />,
    },
    {
      key: 'users',
      label: 'Users',
      children: <PartnerUsersTable />,
    },
  ]

  return (
    <>
      <PtoReferralOverviewCards fetchStats={AppAdmin.getPartnerReferralStats} />

      <Tabs defaultActiveKey="ptos" items={tabItems} destroyInactiveTabPane />
    </>
  )
}
